import type { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    title: {
      inputType: 'text',
      title: 'Subject',
      required: true,
      span: 'full',
    },
    loanNumber: {
      inputType: 'text',
      type: 'number',
      title: 'Loan Number',
      required: false,
      span: 'full',
    },
    description: {
      title: 'Description',
      inputType: 'RichText',
      error: '',
      required: true,
      span: 'full',
      minHeight: 180,
    },
  }
}
